import 'firebase/compat/analytics'
import firebase from 'firebase/compat/app'
import Gleap from 'gleap'

export default (name: string, params?: Record<string, any>) => {
  // Firestore analytics
  firebase.analytics().logEvent(name, params)
  Gleap.trackEvent(name, params)
}
